/** Joins class names, skipping empty ones. */
export const cx = (...c) => c.filter(Boolean).join(" ");
const pct = new Intl.NumberFormat("de-DE", { style: "percent", maximumFractionDigits: 0 });
/** 0.93 → "93 %" */
export const fmtPercent = (v) => pct.format(Number.isFinite(v) ? v : 0);
/**
 * Code and request id of an API error, read from the error object without
 * knowing the app's error class (an error with `code` / `requestId`).
 */
export function errorInfo(err) {
    const message = err instanceof Error ? err.message : String(err ?? "");
    if (err && typeof err === "object") {
        const o = err;
        return {
            message,
            code: typeof o.code === "string" ? o.code : undefined,
            requestId: typeof o.requestId === "string" ? o.requestId : undefined,
        };
    }
    return { message };
}
/** Is the event target a field the user types into (no single-key shortcuts there)? */
export function isTypingTarget(t) {
    if (!(t instanceof HTMLElement))
        return false;
    const tag = t.tagName;
    return tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT" || t.isContentEditable;
}
const validDate = (iso) => !!iso && !Number.isNaN(new Date(iso).getTime());
/**
 * Compact relative age: "gerade", "5 min", "2 h", "3 T" (units from the
 * texts, so i18n apps pass theirs).
 */
export function fmtAge(iso, units = {
    ageNow: "gerade",
    ageMin: "min",
    ageHour: "h",
    ageDay: "T",
}, now = Date.now()) {
    if (!validDate(iso))
        return "–";
    const mins = Math.max(0, Math.round((now - new Date(iso).getTime()) / 60000));
    if (mins < 1)
        return units.ageNow;
    if (mins < 60)
        return `${mins} ${units.ageMin}`;
    const h = Math.floor(mins / 60);
    if (h < 24)
        return `${h} ${units.ageHour}`;
    return `${Math.floor(h / 24)} ${units.ageDay}`;
}
